import React from "react";
import classnames from "classnames";

import style from "./style.module.scss";

interface Props {
    color: "white" | "grey" | "primary" | "lightgrey";
}

export const Separator = ({ color = "primary" }: Props): JSX.Element => {
    return <div className={classnames(style["separator"], style[`${color}`])} data-test-id="separator" />;
};

export default Separator;
